import { useCallback } from 'react'
import { useQuery } from '@graphcommerce/graphql'
import { SocialSignInsDocument } from './SocialSignIns.gql'
import { SignInGoogle } from './SignInGoogle'

export type Social = {
  label?: string | null | undefined
  type?: string | null | undefined
  url?: string | null | undefined
}

export function SignInSocial() {
  // We changed it to no-cache, because after changing the backend url old customers are not able to use social sign ins
  const { data, loading } = useQuery(SocialSignInsDocument, {
    fetchPolicy: 'no-cache',
  })

  const getSocialComponent = useCallback((socialPlatform: Social) => {
    if (socialPlatform.type === 'google') {
      return <SignInGoogle key={socialPlatform?.type} {...socialPlatform} />
    }
    return null
  }, [])

  if (loading) {
    return null
  }

  return (
    <>
      {data?.amSocialLoginButtonConfig?.map((social) =>
        social ? getSocialComponent(social) : null,
      )}
    </>
  )
}
